// utils/offlineStorage/sync.ts - utils/offlineStorage/core.ts class split (methods: sync)

import { OfflineStorage } from './class.js';

declare module './class.js' {
  interface OfflineStorage {
  getLastSyncTime(table: string): Date | null;
  setLastSyncTime(table: string, time?: Date): void;
  getStats(): { totalItems: number; totalSize: number; items: { key: string; size: number; age: number }[] };
  }
}

export function applySyncMethods() {
  Object.assign(OfflineStorage.prototype, {
    /**
   * Get last sync time for a table
   */
  getLastSyncTime(table: string): Date | null {
    try {
      const timestamp = localStorage.getItem(`${this.syncTimeKey}_${table}`);
      return timestamp ? new Date(parseInt(timestamp)) : null;
    } catch {
      return null;
    }
  },
    /**
   * Update last sync time for a table
   */
  setLastSyncTime(table: string, time: Date = new Date()): void {
    try {
      localStorage.setItem(`${this.syncTimeKey}_${table}`, time.getTime().toString());
    } catch (error) {
      console.error('Failed to set sync time:', error);
    }
  },
    /**
   * Get statistics about cache usage
   */
  getStats(): { totalItems: number; totalSize: number; items: { key: string; size: number; age: number }[] } {
    const items: { key: string; size: number; age: number }[] = [];
    let totalSize = 0;

    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(this.prefix)) {
        const value = localStorage.getItem(key) || '';
        const size = new Blob([value]).size;
        const age = this.getCacheAge(key.replace(this.prefix, '')) || 0;
        
        items.push({ key: key.replace(this.prefix, ''), size, age });
        totalSize += size;
      }
    });

    return { totalItems: items.length, totalSize, items };
  },
  });
}
